// Allowed DB names
export const FLOWS_DATABASE_NAME = 'Wegroup - Flows';
